import React, { useState, useEffect } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import './App.css';
import { AuthContext } from './context';
import SnackbarProvider from 'react-simple-snackbar';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from './AppContext';
import 'react-toastify/dist/ReactToastify.css';

const allowedDomains = ['localhost', 'app.aajswift.com'];

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const hostname = window.location.hostname;
  const isAllowedDomain = allowedDomains.includes(hostname);

  const login = (user) => {
    setLoggedIn(true);
    setUser(user);
    localStorage.setItem("isLoggedIn", true);
    if (user) {
      Object.keys(user).forEach((key) => {
        localStorage.setItem(key, user[key]);
      });
    }
  };

  const logout = () => {
    let userId = localStorage.getItem("userid");
    setLoggedIn(false);
    setUser({});
    localStorage.clear();
    localStorage.setItem("userid2", userId);
  };

  const loading = () => <div>Loading...</div>;

  const Login = React.lazy(() => import('./components/signin/login/Login'));
  const LinkVerification = React.lazy(() => import('./components/signin/resetpassword/LinkVerification'));
  const DefaultLayout = React.lazy(() => import('./components/containers/DefaultLayout/DefaultLayout'));
  const TenantLanding = React.lazy(() => import('./components/consignortracking/TenantLanding'));

  return (
    <React.Fragment>
      <ToastContainer />
      <AuthContext.Provider value={{ isLoggedIn: loggedIn, user: user, login: login, logout: logout }}>
        <React.Suspense fallback={loading()}>

          
          {!isAllowedDomain ? (
            <TenantLanding />
          ) : (
            <BrowserRouter>
              <Switch>
                <Route exact path="/login" render={props => <Login {...props} />} />
                <Route exact path="/linkverification" render={props => <LinkVerification {...props} />} />
                <AppProvider>
                  <SnackbarProvider>
                    <Route path="/" render={props => <DefaultLayout {...props} />} />
                  </SnackbarProvider>
                </AppProvider>
              </Switch>
            </BrowserRouter>
          )}
          
        </React.Suspense>
      </AuthContext.Provider>
    </React.Fragment>
  );
}

export default App;
